// extracted by mini-css-extract-plugin
module.exports = {"buttonArrow":"SocialWebButton_buttonArrow__KjpAT","buttonArrowNext":"SocialWebButton_buttonArrowNext__HdHT3","buttonArrowPrev":"SocialWebButton_buttonArrowPrev__6WL0p"};